
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'RepoAnalysisStatus',
  model: {
    prop: 'analysisStatus',
    event: 'toggle'
  },
  props: {
    analysisStatus: {
      type: Boolean,
      required: true
    },
    disableAction: {
      type: Boolean,
      required: true
    },
    isActivated: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    sizing: {
      type: String as PropType<'base' | 'small'>,
      default: 'base'
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.analysisStatus
      },
      set(value: boolean) {
        this.$emit('toggle', value)
      }
    }
  }
})
